import React, { Component } from 'react'
import { connect } from 'react-redux'
import { requestService, getService } from '../../../ducks/addons'
import { requestApp, getApp } from '../../../ducks/apps'
import Page from '../../Shared/Page'
import EmptyState from '../../Shared/EmptyState'
import Loading from '../../Shared/Loading'

class InstallAddonPage extends Component {
  componentDidMount() {
    const { match, requestApp, requestService } = this.props
    const { appId, serviceId } = match.params

    requestApp(appId)
    requestService(serviceId)
  }

  render() {
    const { service } = this.props

    if (!service) {
      return (
        <EmptyState greedy>
          <Loading large />
        </EmptyState>
      )
    }

    return (
      <Page form title={`Install ${service.name}`}>
        <div className="install-addon-page">
          <h1>
            Install
            {service.name}
          </h1>
        </div>
      </Page>
    )
  }
}

const mapStateToProps = (state, { match }) => ({
  service: getService(state, match.params.serviceId),
  app: getApp(state, match.params.appId),
})

export default connect(mapStateToProps, { requestApp, requestService })(
  InstallAddonPage
)
